import { ContentLimiter } from 'components/atoms';
import { ContentRow } from 'components/molecules';
import { KSV, PurchasableDocument } from 'components/profiles';
import React from 'react';
import { UnternehmenDto } from 'types/unternehmen';
import { useTranslation } from 'utils/hooks';


interface DokumenteProps
{
  unternehmen: UnternehmenDto;
}

const Dokumente: React.FC<DokumenteProps> = (props) =>
{
  const { unternehmen } = props;
  const { t } = useTranslation('profiles');

  function getAuszugAtDocumentLink(fbNr: string)
  {
    return `https://firmenbuch.auszug.at/unternehmen/${fbNr}`;
  }

  return (
    <>
      {/* Bonität & Dokumente */}
      <ContentRow id="dokumente" title={t('profiles:unternehmen.documents.label')}>

        <KSV fbNr={unternehmen.fbNr} />

        <hr style={{ marginBlock: '1rem' }} />

        <ul className="no-list-style">
          <ContentLimiter initialLimit={3} stepSize={5}>
            {[
              <PurchasableDocument
                key="fbAuszugAktuell"
                text={t('profiles:unternehmen.documents.fbAuszugAktuell')}
                href={getAuszugAtDocumentLink(unternehmen.fbNr)}
              />,

              <PurchasableDocument
                key="fbAuszugHistorisch"
                text={t('profiles:unternehmen.documents.fbAuszugHistorisch')}
                href={getAuszugAtDocumentLink(unternehmen.fbNr)}
              />,

              ...unternehmen.jahresabschlüsse.sort((a, b) => b.dueDate.localeCompare(a.dueDate)).map((jahresabschluss) => (
                <PurchasableDocument
                  key={jahresabschluss.dueDate + jahresabschluss.submissionDate}
                  text={t('profiles:unternehmen.documents.jahresabschluss', { dueDate: jahresabschluss.dueDate, submissionDate: jahresabschluss.submissionDate })}
                  href={getAuszugAtDocumentLink(unternehmen.fbNr)}
                />
              )),
            ]}
          </ContentLimiter>
        </ul>
      </ContentRow>

    </>
  );
};

export default Dokumente;
